import { render } from "./ProfileTest.vue?vue&type=template&id=f1a76a8c&scoped=true"
import script from "./ProfileTest.vue?vue&type=script&lang=js"
export * from "./ProfileTest.vue?vue&type=script&lang=js"

import "./ProfileTest.vue?vue&type=style&index=0&id=f1a76a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a76a8c"]])

export default __exports__